module.exports = __webpack_public_path__ + "img/logo_ready_to_move.938a4887.png";